import React from 'react'

const ModerContext = React.createContext({})

export const ModerProvider = ModerContext.Provider
export default ModerContext
